import type { Ref } from 'vue'

import { readonly, ref } from 'vue'

interface UseCommandPaletteReturn {
  isOpen: Readonly<Ref<boolean>>
  open: () => void
  close: () => void
  toggle: () => void
}

const isOpen = ref(false)

const open = () => {
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

const toggle = () => {
  isOpen.value = !isOpen.value
}

export const useCommandPalette = (): UseCommandPaletteReturn => ({
  isOpen: readonly(isOpen),
  open,
  close,
  toggle
})
